"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1",
    id: "path9015"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    x: "8.64781",
    y: "8.4507294",
    width: "13.5",
    height: "13.5",
    rx: "1.5",
    ry: "1.5",
    id: "rect9039",
    strokeWidth: "2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
    x1: "13.119707",
    y1: "13.002919",
    x2: "17.595619",
    y2: "17.478832",
    id: "line9041",
    strokeWidth: "2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
    x1: "17.595619",
    y1: "13.002919",
    x2: "13.119707",
    y2: "17.478832",
    id: "line9043",
    strokeWidth: "2"
  })]
}));